import React, { useState,useRef } from "react";
import { Button, Divider ,Card} from "antd";

import { useNavigate } from "react-router-dom";
import ResumeResultsCard from "../resumeResultsCard";
import "./resumeResultsCardList.scss";
import linkIcon from "../../assets/brokenLink.png";
import RDBTable from "../RDBTable";
import useRDBStore from "../../store/rdb";

import ResumeResultsApplicationViewCard from "../resumeResultsApplicationViewCard";

export default function ResumeResultsCardList({
    pageResult,data,pendingRDBMetaData,page, pageSize
}) {
    const [currentView, setCurrentView] = useState("ResumeView");
    var userData = JSON.parse(localStorage.getItem("userDetails")); 
    const {rdbLinkUserMetaData}  = useRDBStore()
    const [currentUserMetaData, setCurrentMetatData] = useState(rdbLinkUserMetaData);
    const LinkedResumeListTable = [
        "Sr. No.",
        "Linked on",
        "JD ID",
        "JD Title",        
        "Link Status",
        "Resume ID",
        "Name",
        "Email",       
        "Mobile",  
        "Ownership",
        "Expiry Date",
        "Remarks",
    ];     

    const navigate = useNavigate();
    const handleRDBJDClick = (id,jdId,resumeID) =>{
       console.log("Redirecto fo JD", id, jdId)
       navigate(`/jds/${jdId}`, { state: { newView: "summary" ,searchResumeID:resumeID} });       
    }

    const linkedData = currentUserMetaData?.map((uMetadata, idx) => { 
        return {
            id: idx+1,
            linkedOn: uMetadata?.linkedon,
            jdId:  uMetadata?.qhcompanyjid,
            jdTitle: uMetadata?.title,            
            status: uMetadata?.linkstatus,
            resumeID: uMetadata?.qhrid,
            name: uMetadata?.name,
            email: uMetadata?.email,
            mobile: uMetadata?.mobile,
            ownership: uMetadata?.ownership,
            ownershipexpirydate: uMetadata?.ownershipexpirydate,
            remarks: uMetadata?.remarks,
        };
    });
    const updateAppsMetaData = (resume) =>{
        var favFlag = false
        var followFlag = false
        var viewFlag = false
        var linkedFlag = false
        resume?.appsmetadata?.map((mData)=>{
            if(mData.qhuid === userData.qhuid && mData.name === userData.username){
             favFlag = mData.favourites
             followFlag = mData.follow
             viewFlag = mData.viewed
             linkedFlag = mData.linked             
            }
        })              
        return ({
             isfavorite:favFlag,
             isFollow:followFlag,
             isLinked:linkedFlag,
             isViewed:viewFlag,
        })                                         
    } 
    return (
        <div className="resumeResultsCardList-wrapper">
        <div className="resumeResultsCardList-Top">
          <div className="resumeResultsCardList-buttons">
            <Button
              className={`candidate-description-btn ${
                currentView === "ResumeView" && "candidate-description-btn-active"
              }`}
              onClick={(e) => {
                setCurrentView("ResumeView");
              }}
            >
              Resumes View
            </Button>
            <Button
              className={`candidate-description-btn ${
                currentView === "ApplicationView" &&
                "candidate-description-btn-active"
              }`}
              onClick={(e) => {
                setCurrentView("ApplicationView");
              }}
            >
              Applications View
            </Button>            
          </div>
          <div className="resumeResultsCardList-Icons">
                 <div>
                  <img
                      src={linkIcon}
                      alt="Linked"
                      width="20" height="20"
                      className="image"
                      onClick={(e) => {
                                        setCurrentView("LinkedView");
                                      }}
                  />
                 </div>

                 <div className="resumeResultsCardList-Icons-items">
                    ({currentUserMetaData==null?0:currentUserMetaData?.length})
                 </div>
                    
          </div>
        </div>
            {
                currentView == "ResumeView"?
                <>
                    <div >
                        {data?.map((foundresume,idx) => (                                                        
                            <ResumeResultsCard 
                                pageResult = {pageResult} 
                                resume = {foundresume?.resume}
                                applications= {foundresume?.applications}
                                metaData = {updateAppsMetaData(foundresume?.resume)}
                                pendingRDBMetaData ={pendingRDBMetaData}
                                setUserMetaData = {setCurrentMetatData}
                                />
                        ))}
                    </div>                
                </>
                : currentView == "ApplicationView"?
                <>    
                    <div >
                        {data?.map((foundresume,idx) => (
                            <ResumeResultsApplicationViewCard 
                              jdClickHandler = {handleRDBJDClick}
                              jdList={pageResult?.jdidlist}
                              resume= {foundresume?.resume} 
                              applications= {foundresume?.applications}/>   
                        ))}
                    </div>              
                </>
                : <>    
                    <div className= "resumeResultsCard-application-wrapper" >
                        { 
                          <RDBTable
                             titleList={LinkedResumeListTable}
                             data={linkedData}
                             columnWidth={`50px 2fr 3fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr`}
                             emptyString ={"No Linked Profiles"}
                             showButton = {true}
                             setUserMetaData = {setCurrentMetatData}
                          />}
                    </div>              
                </>                                
            }
        </div>
    );
}
